<template>
  <div class="map-layout">

    <!-- 🗺 КАРТА: монтируется ТОЛЬКО на desktop -->
    <div v-if="showMap" class="map-pane">
      <MapPane :properties="properties" />
    </div>

    <!-- 📋 СПИСОК: всегда виден -->
    <div class="list-pane">
      <MiniFilterBar @update="onFilterUpdate" />
      <PropertyCards :properties="properties" />
    </div>

  </div>
</template>

<script setup>
import { ref, onMounted, onBeforeUnmount, watch } from 'vue'
import { storeToRefs } from 'pinia'
import { useLanguageStore } from '../../../stores/languageStore'
import { useFilterStore } from '../../../stores/filterStore'

import MiniFilterBar from '../components/MiniFilterBar.vue'
import PropertyCards from '../pages/property_list/PropertyCards.vue'
import MapPane from '../pages/property_map/MapPane.vue'

/* 🌍 язык */
const languageStore = useLanguageStore()
const { locale } = storeToRefs(languageStore)

/* 🧭 фильтры */
const filterStore = useFilterStore()

/* 📦 данные */
const properties = ref([])

/* 🗺 показывать ли карту */
const showMap = ref(false)

/* media query — ТОЛЬКО desktop */
const mediaQuery = window.matchMedia('(min-width: 1024px)')

function updateLayout() {
  showMap.value = mediaQuery.matches
}

/* 🔄 загрузка объектов */
async function fetchProperties(filters = {}) {
  const xLocale = (locale.value || 'ru').split('-')[0]

  const params = new URLSearchParams({
    ...filterStore.$state,
    ...filters,
    per_page: 200,
    locale: xLocale
  })

  const res = await fetch(`/api/v1/properties?${params}`, {
  headers: {
    'X-Locale': xLocale
  }
})
  const data = await res.json()

  properties.value = data.properties || []
}

/* 🎯 событие фильтра */
function onFilterUpdate(filters) {
  filterStore.setFilters(filters)
  fetchProperties(filters)
}

/* 🚀 старт */
onMounted(() => {
  updateLayout()
  mediaQuery.addEventListener('change', updateLayout)
  fetchProperties()
})

onBeforeUnmount(() => {
  mediaQuery.removeEventListener('change', updateLayout)
})

/* 🌍 обновление при смене языка */
watch(locale, () => fetchProperties())
</script>

<style scoped>

/* =================================================
   MOBILE FIRST — СПИСОК ВСЕГДА ВИДЕН
================================================= */

.map-layout {
  display: flex;
  flex-direction: column;
  height: 100%;
  background: #f8f9fa;
}

.list-pane {
  flex: 1;
  overflow-y: auto;
  padding: 8px;
}

/* =================================================
   DESKTOP — КАРТА + СПИСОК
================================================= */

@media (min-width: 1024px) {
  .map-layout {
    display: grid;
    grid-template-columns: 50% 50%;
    height: calc(100vh - 60px);
  }

  .map-pane {
    height: 100%;
    min-height: 0; /* важно для grid */
  }

  .list-pane {
    padding: 12px;
    overflow-y: auto;
  }
}

</style>
